var map = {
	"./facebook.svg": 6252,
	"./instagram.svg": 8284,
	"./linkedin.svg": 1862,
	"./snapchat.svg": 4614,
	"./telegram.svg": 1209,
	"./tiktok.svg": 7710,
	"./twitter.svg": 1917,
	"./whatsapp.svg": 9962,
	"./youtube.svg": 1651
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9502;